import React from 'react';
import { Link } from 'react-router-dom';
import { fundSectionHref, fundSections, home, routes } from '../../models/content';
import V2CtaDark from '../components/V2CtaDark';

export default function V2HomePage() {
  return (
    <>
      <main>
        <section className="home-hero">
          <div className="wrap">
            <span className="v2-badge">
              <span className="dot" />
              {home.badge}
            </span>

            <h1>
              {home.headlineLines.map((line, idx) => (
                <React.Fragment key={idx}>
                  {Array.isArray(line)
                    ? line.map((part, i) =>
                        typeof part === 'string' ? (
                          <React.Fragment key={i}>{part}</React.Fragment>
                        ) : (
                          <span key={i} className="it">
                            {part.it}
                          </span>
                        )
                      )
                    : null}
                  <br />
                </React.Fragment>
              ))}
            </h1>

            <p className="sub">{home.subhead}</p>

            <div className="cta-row">
              <Link to={routes.fund} className="btn btn-primary btn-lg">
                Know More →
              </Link>
              <Link to={routes.contact} className="btn btn-ghost btn-lg">
                Get in Touch
              </Link>
            </div>

            <div className="stat-strip">
              {home.stats.map((s) => (
                <div className="item" key={s.label}>
                  <div className="v">
                    {s.value}
                    {s.valueUnit ? <span className="unit">{s.valueUnit}</span> : null}
                    {s.valueSub ? <span className="sub-stat"> {s.valueSub}</span> : null}
                    {s.valueEm ? <span className="em">{s.valueEm}</span> : null}
                    {s.suffix ?? ''}
                  </div>
                  <div className="l">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="strategy-v2">
          <div className="wrap">
            <div className="head">
              <span className="kicker">Our Strategy</span>
              <h2>
                Our investment thesis envisages participation in the <span className="it">value-creation process</span>{' '}
                while preserving the invested capital.
              </h2>
            </div>
            <div className="pillars">
              <article className="pillar">
                <span className="bg-num">01</span>
                <span className="eyebrow">Pillar 01</span>
                <h3>How Do We Operate?</h3>
                <Link to={fundSectionHref(fundSections.operate)} className="more">
                  Know More →
                </Link>
              </article>
              <article className="pillar">
                <span className="bg-num">02</span>
                <span className="eyebrow">Pillar 02</span>
                <h3>How Do We Contribute?</h3>
                <Link to={fundSectionHref(fundSections.contribute)} className="more">
                  Know More →
                </Link>
              </article>
              <article className="pillar">
                <span className="bg-num">03</span>
                <span className="eyebrow">Pillar 03</span>
                <h3>How Do We Add Value To Our Investors?</h3>
                <Link to={fundSectionHref(fundSections.addValue)} className="more">
                  Know More →
                </Link>
              </article>
            </div>
          </div>
        </section>
      </main>

      <V2CtaDark />
    </>
  );
}

